import type { ReactNode } from 'react';
import { STATUS_LABEL } from '../marketing/Common';

export type StatusTone =
  | 'draft' | 'active' | 'paused' | 'completed' | 'cancelled'
  | 'success' | 'warning' | 'error' | 'neutral' | 'info';

/** Тон → класс .mk-chip (green/amber/indigo/red/blue/''). */
const TONE_CLASS: Record<StatusTone, string> = {
  draft: '',
  neutral: '',
  active: 'green',
  success: 'green',
  paused: 'amber',
  warning: 'amber',
  completed: 'indigo',
  cancelled: 'red',
  error: 'red',
  info: 'blue',
};

export function statusToneClass(tone: StatusTone): string {
  return TONE_CLASS[tone];
}

/** Бейдж статуса. plain — без рамки (в таблицах). */
export function StatusTag({
  tone,
  children,
  plain = false,
  className = '',
}: {
  tone: StatusTone;
  children: ReactNode;
  plain?: boolean;
  className?: string;
}) {
  return (
    <span className={['mk-chip', TONE_CLASS[tone], plain ? 'mk-plain' : '', className].filter(Boolean).join(' ')}>
      {children}
    </span>
  );
}

/** Статус кампании API → тон бейджа. */
export function campaignStatusTone(status: string): StatusTone {
  switch (status) {
    case 'draft':
      return 'draft';
    case 'active':
    case 'running':
    case 'scheduled':
    case 'sending':
      return 'active';
    case 'paused':
      return 'paused';
    // Пакет 7b, п.23: кампания ждёт решения УК — «в пути», синий тон (не работает и не остановлена).
    case 'pending_approval':
      return 'info';
    case 'completed':
    case 'done':
      return 'completed';
    case 'cancelled':
    case 'canceled':
    case 'stopped':
    case 'failed':
      return 'cancelled';
    default:
      return 'neutral';
  }
}

/** Подпись статуса из STATUS_LABEL (Common.tsx); неизвестный статус — как есть. */
export function campaignStatusLabel(status: string): string {
  return STATUS_LABEL[status] ?? status;
}
